<template>
  <card style="height: 100%;">
    <div
      v-if="metes.length === 1"
      class="device-picker"
      style="right: auto;left: 20px;top: 12px;"
    >
      {{ metes[0].name }}
    </div>

    <el-select
      v-else
      class="device-picker left"
      popper-class="device-picker__popper"
      size="mini"
      style="right: auto;left: 20px;top: 12px;"
      :value="deviceId"
      @input="deviceChange"
    >
      <el-option
        v-for="item in metes"
        :key="item.id"
        :label="item.name"
        :value="item.id"
      >
      </el-option>
    </el-select>

    <echart
      v-if="!loading && series.length"
      :chartId="chartId"
      :options="options"
      :height="height - 52"
      style="margin-top: 52px;"
    ></echart>
  </card>
</template>

<script>
import mixin from '../mixin'
import Card from '../card'
import Echart from '@/components/Chart'

const ARROW_SIZE = 12
function getRenderArrow(index) {
  return function renderArrow(param, api) {
    const point = api.coord([api.value(0), api.value(index)])

    return {
      type: 'path',
      shape: {
        pathData: 'M31 16l-15-15v9h-26v12h26v9z',
        x: -ARROW_SIZE / 2,
        y: -ARROW_SIZE / 2,
        width: ARROW_SIZE,
        height: ARROW_SIZE
      },
      rotation: -((api.value(param.encode.y[0]) + 90) * Math.PI) / 180,
      position: point,
      style: api.style({ stroke: '#fff', lineWidth: 1 })
    }
  }
}

export default {
  mixins: [mixin],
  components: { Card, Echart },
  props: {
    chartId: String,
    cols: Array,
    data: Array,
    group: Array,
    loading: Boolean
  },
  computed: {
    options() {
      return {
        legend: {
          type: 'scroll',
          left: 52,
          right: '6%',
          bottom: 12,
          pageButtonGap: 20,
          textStyle: { color: '#9aa8d4' },
          pageTextStyle: { color: '#dcdfe6', fontSize: 14 }
        },
        tooltip: {
          transitionDuration: 0
        },
        grid: [
          {
            top: 40,
            left: 52,
            right: 52,
            bottom: '75%'
          },
          {
            top: '35%',
            left: 52,
            right: 52,
            bottom: '40%'
          },
          {
            top: '70%',
            left: 52,
            right: 52,
            bottom: '10%'
          }
        ],
        xAxis: [
          {
            type: 'category',
            gridIndex: 0,
            splitLine: false
          },
          {
            type: 'category',
            // boundaryGap: false,
            gridIndex: 1,
            splitLine: false
          },
          {
            type: 'category',
            // boundaryGap: false,
            gridIndex: 2,
            splitLine: false
          }
        ],
        yAxis: this.yAxis,
        dataset: this.dataset,
        series: this.series
      }
    },
    keys() {
      let keys = []
      let yIndex = 0
      this.group.forEach((k, xIndex) => {
        if (!Array.isArray(k)) return
        k.forEach(kk => {
          const col = this.cols.find(c => c.name === kk)
          if (!col) return
          const isWindD = kk === '风向'
          keys.push({
            key: col.key,
            type: kk === '降雨量' ? 'bar' : isWindD ? 'custom' : 'line',
            name: kk,
            xIndex,
            yIndex: isWindD ? 0 : yIndex
          })
          yIndex += 1
        })
      })
      return keys
    },
    yAxis() {
      let axis = []
      this.group.map((k, index) => {
        if (!Array.isArray(k)) return
        k.forEach(kk => {
          let max
          if (kk === '风速') {
            // const data = this.data.map(o => )
            const col = this.keys.find(key => key.name === '风速')
            if (col) {
              const data = this.data.map(d => d[col.key])
              max = Math.ceil(Math.max(...data) + 1)
            }
          }
          axis.push({
            gridIndex: index,
            name: kk,
            splitLine: false,
            max,
            show: kk !== '风向'
          })
        })
      })
      return axis
    },
    dataset() {
      return {
        // dimensions: ['date'].concat(this.keys.map(c => c.key)),
        source: this.data.map(d =>
          [d.date].concat(this.keys.map(k => d[k.key]))
        )
      }
    },
    series() {
      return this.keys.map((k, index) => {
        const isWindD = k.name === '风向'
        const windSIndex = isWindD
          ? this.keys.findIndex(k => k.name === '风速') + 1
          : 0

        return {
          // type: k.key === 'Rainfall' ? 'bar' : 'line',
          type: k.type,
          // barWidth: '40%',
          name: k.name,
          xAxisIndex: k.xIndex,
          yAxisIndex: k.yIndex,
          renderItem: isWindD ? getRenderArrow(windSIndex) : null,
          symbol: 'none',
          z: k.name === '风向' ? 10 : 2,
          encode: {
            x: 'date',
            y: index + 1
          }
        }
      })
    }
  }
}
</script>

<style lang="css" scoped></style>
